import React from 'react';

//export const PriceColumnFormatter = (cellContent, row) => <>{row.price}₮</>;
export function PriceColumnFormatter(cellContent, row) {
  const getLabelCssClasses = () => {
    return `text-right`;
  };
  return (
    <div className={getLabelCssClasses()}>
      {cellContent &&
        cellContent.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ',')}
      ₮
    </div>
  );
}
